import { useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { ResourceStats } from "types";

const useGetStats = () => {
  const resourcesStats = useSelector((state: RootStateOrAny) => {
    return state.reports && state.reports.resourcesStats;
  });

  const submissionsStats = useMemo(() => {
    if (!resourcesStats || !Array.isArray(resourcesStats)) {
      return [];
    }
    return resourcesStats.filter(
      (rs: ResourceStats) =>
        rs.assignmentType === "WORKSHEET" || rs.assignmentType === "ASSESSMENT"
    );
  }, [resourcesStats]);

  return { resourcesStats, submissionsStats };
};

export default useGetStats;
